import { render, staticRenderFns } from "./Microflavours.vue?vue&type=template&id=0aade0b2&"
import script from "./Microflavours.vue?vue&type=script&lang=js&"
export * from "./Microflavours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports